import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiTransDbComponent } from './ui-trans-db/ui-trans-db.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { UiTransAccountsComponent } from './ui-trans-accounts/ui-trans-accounts.component';



@NgModule({
  declarations: [UiTransDbComponent, UiTransAccountsComponent],
  imports: [
    CommonModule,
    RouterModule, 
    ReactiveFormsModule,
  ]
})
export class UiTransModule { }
